module.exports = __webpack_public_path__ + "static/flower-e30ab4b56b2773e985916a4d8ba5fd6a.png";